import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeAuthMethod} from "../../tracking/types/AmplitudeAuthMethod";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";

type LoginEventName = "logged_in" | "login_click" | "login_form_view";
type SignUpEventName = "signed_up" | "sign_up_click" | "sign_up_form_view";

interface ILoginEventParams {
    loginMethod: AmplitudeAuthMethod;
    loginPlacement: AmplitudeAuthPlacement;
}

interface ISignUpEventParams {
    signUpMethod: AmplitudeAuthMethod;
    signUpPlacement: AmplitudeAuthPlacement;
}

export const trackAmplitudeAuthEvent = (event: LoginEventName | SignUpEventName, params: ILoginEventParams | ISignUpEventParams) => {
    if ("loginMethod" in params) {
        trackAmplitudeEvent(event, {
            login_method: params.loginMethod,
            login_placement: params.loginPlacement
        });
    } else {
        trackAmplitudeEvent(event, {
            sign_up_method: params.signUpMethod,
            sign_up_placement: params.signUpPlacement
        });
    }
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeAuthMethod} from "../../tracking/types/AmplitudeAuthMethod";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";

type LoginEventName = "logged_in" | "login_click" | "login_form_view";
type SignUpEventName = "signed_up" | "sign_up_click" | "sign_up_form_view";

interface ILoginEventParams {
    loginMethod: AmplitudeAuthMethod;
    loginPlacement: AmplitudeAuthPlacement;
}

interface ISignUpEventParams {
    signUpMethod: AmplitudeAuthMethod;
    signUpPlacement: AmplitudeAuthPlacement;
}

export const trackAmplitudeAuthEvent = (event: LoginEventName | SignUpEventName, params: ILoginEventParams | ISignUpEventParams) => {
    if ("loginMethod" in params) {
        trackAmplitudeEvent(event, {
            login_method: params.loginMethod,
            login_placement: params.loginPlacement
        });
    } else {
        trackAmplitudeEvent(event, {
            sign_up_method: params.signUpMethod,
            sign_up_placement: params.signUpPlacement
        });
    }
};
